// apps/web/src/features/auth/components/AuthLayout.tsx
// Centered-card chrome for unauthenticated surfaces (/login today; future
// /reset-password, /accept-invite would reuse the same wrapper).
//
// Token contract — no literal colors / sizes, everything routed through
// colors_and_type.css variables so dark-theme + eventual rebrand keep working:
//   page bg  → --bg-0, card bg → --bg-1, divider → --border-1,
//   card radius → --r-3 (same as Modal/Drawer), lift → --shadow-2.
// Wordmark uses --font-display (Newsreader serif) at --fz-22 to match the
// visual tone of the logo shown in the shell topbar while reading as a
// page-level brand anchor, not a generic heading.
import type { ReactNode } from 'react';
import { LocaleSwitcher } from '../../../shell/LocaleSwitcher.js';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--s-7)',
        background: 'var(--bg-0)',
      }}
    >
      <section
        aria-labelledby="auth-title"
        style={{
          width: '100%',
          maxWidth: 420,
          background: 'var(--bg-1)',
          border: '1px solid var(--border-1)',
          borderRadius: 'var(--r-3)',
          boxShadow: 'var(--shadow-2)',
          padding: 'var(--s-8)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--s-4)' }}>
          <LocaleSwitcher />
        </div>
        <header style={{ marginBottom: 'var(--s-7)' }}>
          <div
            aria-label="magimp"
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'var(--fz-22)',
              fontWeight: 500,
              color: 'var(--fg-1)',
              letterSpacing: '-0.01em',
              marginBottom: 'var(--s-4)',
            }}
          >
            magimp
          </div>
          <h1
            id="auth-title"
            style={{
              fontFamily: 'var(--font-ui)',
              fontSize: 'var(--fz-18)',
              fontWeight: 600,
              color: 'var(--fg-1)',
              margin: 0,
              marginBottom: subtitle ? 'var(--s-3)' : 0,
            }}
          >
            {title}
          </h1>
          {subtitle ? (
            <p
              style={{
                fontFamily: 'var(--font-ui)',
                fontSize: 'var(--fz-13)',
                color: 'var(--fg-2)',
                margin: 0,
              }}
            >
              {subtitle}
            </p>
          ) : null}
        </header>
        {children}
        {footer ? (
          <footer
            style={{
              marginTop: 'var(--s-7)',
              paddingTop: 'var(--s-5)',
              borderTop: '1px solid var(--border-2)',
              fontSize: 'var(--fz-12)',
              color: 'var(--fg-3)',
              textAlign: 'center',
            }}
          >
            {footer}
          </footer>
        ) : null}
      </section>
    </main>
  );
}
